var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.meeting.decisions && _vm.meeting.decisions.length)?_c('div',[_c('strong',[_vm._v("Arbitrages rendus :")]),_vm._v(" "),_c('ul',_vm._l((_vm.meeting.decisions),function(issue){return _c('li',{key:issue.id},[_c('span',[_vm._v(_vm._s(issue.title)+" -> "+_vm._s(issue.decision))])])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }